import { render, staticRenderFns } from "./BlockedOverlay.vue?vue&type=template&id=084a2f63&scoped=true&"
import script from "./BlockedOverlay.vue?vue&type=script&lang=js&"
export * from "./BlockedOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BlockedOverlay.vue?vue&type=style&index=0&id=084a2f63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a2f63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
